import { useStarterRestoreAuthRepo } from "../../authentication/repositories/useStarterRestoreAuthRepo";

export const useStarterLayoutController = () => {
  const {
    state: { loading, isAuthenticated },
  } = useStarterRestoreAuthRepo();

  return {
    state: {
      loading,
      isAuthenticated,
    },
  };
};
